import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

const buildClientOrdersQuery = ({ page, rowsPerPage, search }) => {
  if (search) {
    return `?search=${search}&limit=${1000}&page=${0}`;
  }
  return `?page=${page}&limit=${rowsPerPage}`;
};

export const GetAllWebhookLocks =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      const response = await GetFunction({
        data: {},
        Route: UrlApi.webhook_locks.get,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const GetWebhookLocksByOrderId =
  ({ orderId, callback }) =>
  async (dispatch, getState) => {
    try {
      const response = await GetFunction({
        data: {},
        Route: `${UrlApi.webhook_locks.by_order}/${orderId}`,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const GetDuplicateOrders =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      const response = await GetFunction({
        data: {},
        Route: UrlApi.webhook_locks.duplicate_orders,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const GetDuplicateCourses =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      const response = await GetFunction({
        data: {},
        Route: UrlApi.webhook_locks.duplicate_courses,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const GetDiagnosticByOrderId =
  ({ orderId, callback }) =>
  async (dispatch, getState) => {
    try {
      const response = await GetFunction({
        data: {},
        Route: `${UrlApi.webhook_locks.diagnostic}/${orderId}`,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const GetClientOrdersAdmin =
  ({ callback, page, rowsPerPage, search }) =>
  async (dispatch, getState) => {
    try {
      const query = buildClientOrdersQuery({ page, rowsPerPage, search });
      const response = await GetFunction({
        data: {},
        Route: UrlApi.client_orders.get + query,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };
